import {
    apiRequest,
    LocationDetail,
    LocationUpdate
} from "../../../../../services/adapters/master/locationPresenceService"

class CreateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", LocationDetail, {
            params: query
        }, true)
    }
    fetchUpdate = async (query) => {
        return await apiRequest("post", LocationUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository